// src/i18n/index.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files from locales directory
import enCommon from '../locales/en/common.json';
import enHome from '../locales/en/home.json';
import enAbout from '../locales/en/about.json';
import enContact from '../locales/en/contact.json';
import enBlog from '../locales/en/blog.json';
import enNyahBeku from '../locales/en/nyahbeku.json';
import enToilet from '../locales/en/toilet.json';
import enWhatgmp from '../locales/en/whatgmp.json';
import enGallery from '../locales/en/gallery.json';
import enManagementTraining from '../locales/en/managementTraining.json';
import enConsultancyServices from '../locales/en/consultancyServices.json';
import enFssc from '../locales/en/fssc.json';
import enIso22000 from '../locales/en/iso22000.json';
import enHaccp from '../locales/en/haccp.json';
import enGmp from '../locales/en/gmp.json';
import enGdpmd from '../locales/en/gdpmd.json';
import enIso9001 from '../locales/en/iso9001.json';
import enGmpplus from '../locales/en/gmpplus.json';

import msCommon from '../locales/ms/common.json';
import msHome from '../locales/ms/home.json';
import msAbout from '../locales/ms/about.json';
import msContact from '../locales/ms/contact.json';
import msBlog from '../locales/ms/blog.json';
import msNyahBeku from '../locales/ms/nyahbeku.json';
import msToilet from '../locales/ms/toilet.json';
import msWhatgmp from '../locales/ms/whatgmp.json';
import msGallery from '../locales/ms/gallery.json';
import msManagementTraining from '../locales/ms/managementTraining.json';
import msConsultancyServices from '../locales/ms/consultancyServices.json';
import msFssc from '../locales/ms/fssc.json';
import msIso22000 from '../locales/ms/iso22000.json';
import msHaccp from '../locales/ms/haccp.json';
import msGmp from '../locales/ms/gmp.json';
import msGdpmd from '../locales/ms/gdpmd.json';
import msIso9001 from '../locales/ms/iso9001.json';
import msGmpplus from '../locales/ms/gmpplus.json';

// Translation resources
const resources = {
  en: {
    common: enCommon,
    home: enHome,
    about: enAbout,
    contact: enContact,
    blog: enBlog,
    nyahbeku: enNyahBeku,
    toilet: enToilet,
    whatgmp: enWhatgmp,
    gallery: enGallery,
    managementTraining: enManagementTraining,
    consultancyServices: enConsultancyServices,
    fssc: enFssc,
    iso22000: enIso22000,
    haccp: enHaccp,
    gmp: enGmp,
    gdpmd: enGdpmd,
    iso9001: enIso9001,
    gmpplus: enGmpplus,
  },
  ms: {
    common: msCommon,
    home: msHome,
    about: msAbout,
    contact: msContact,
    blog: msBlog,
    nyahbeku: msNyahBeku,
    toilet: msToilet,
    whatgmp: msWhatgmp,
    gallery: msGallery,
    managementTraining: msManagementTraining,
    consultancyServices: msConsultancyServices,
    fssc: msFssc,
    iso22000: msIso22000,
    haccp: msHaccp,
    gmp: msGmp,
    gdpmd: msGdpmd,
    iso9001: msIso9001,
    gmpplus: msGmpplus,
  },
};

// Language detection configuration
const detectionOptions = {
  order: ['localStorage', 'navigator', 'htmlTag'],
  caches: ['localStorage'],
  lookupLocalStorage: 'preferred-language',
  checkWhitelist: true,
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en', // Default language
    fallbackLng: 'en',
    debug: process.env.NODE_ENV === 'development',
    
    detection: detectionOptions,
    
    interpolation: {
      escapeValue: false, // React already escapes by default
    },
    
    // Namespace configuration
    defaultNS: 'common',
    ns: ['common', 'home', 'about', 'contact', 'blog', 'nyahbeku', 'toilet', 'whatgmp', 'gallery', 'managementTraining',
      'consultancyServices', 'fssc', 'iso22000', 'haccp', 'gmp', 'gdpmd', 'iso9001', 'gmpplus'
    ],
    
    // Key separator configuration
    keySeparator: '.',
    nsSeparator: ':',
    
    // React i18next options
    react: {
      useSuspense: false,
      bindI18n: 'languageChanged loaded',
      bindI18nStore: 'added removed',
      transEmptyNodeValue: '',
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p'],
    },
    
    // Whitelist supported languages
    supportedLngs: ['en', 'ms'],
    nonExplicitSupportedLngs: false,
    load: 'languageOnly',
    
    // Save missing keys in development
    saveMissing: process.env.NODE_ENV === 'development',
    missingKeyHandler: (lng, ns, key, fallbackValue) => {
      if (process.env.NODE_ENV === 'development') {
        console.warn(`Missing translation key: ${lng}.${ns}.${key}`);
      }
    },
  });

export default i18n;